// extracted by mini-css-extract-plugin
export default {"report-block":"ReportBlockPreview_report-block__+LW6S"};